import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isUtilitiesMustIncludedInPrice } from './price/isUtilitiesMustIncludedInPrice';
import { getRentPrice } from './price/rent/getRentPrice';
import { getRentPriceWithUtilities } from './price/rent/getRentPriceWithUtilities';
import { getSalePrice } from './price/sale/getSalePrice';
import { getRegionId } from './utils/getRegionId';

export const price: TComputedPropMapper<string> = ({ offer, featureToggle: { utilitiesTermsSettings } }) => {
  if (offer.dealType === 'rent') {
    const { bargainTerms, category, geo } = offer;
    const { utilitiesTerms, priceRur } = bargainTerms;

    const regionId = geo ? getRegionId(geo) : null;

    if (
      utilitiesTerms &&
      regionId &&
      isUtilitiesMustIncludedInPrice(
        { regionId, includedInPrice: utilitiesTerms.includedInPrice },
        utilitiesTermsSettings,
      )
    ) {
      return getRentPriceWithUtilities({ priceRur, utilitiesPriceRur: utilitiesTerms.price, category });
    } else {
      return getRentPrice({ priceRur, category });
    }
  } else {
    return getSalePrice(offer);
  }
};
